export default __webpack_public_path__ + "static/media/oral-thrush.eb380563.png";